import { createSelector } from 'reselect'

const getSquad = state => state.squad
const getRoster = state => state.roster

const getAvailableUnitsFromRoster = createSelector(
    getSquad,
    getRoster,
    (squad, roster) => (Object.values(roster).filter(unit => !squad.includes(unit.ID)))
)

export default getAvailableUnitsFromRoster

